import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=685bfc5d&"
import script from "./Contacts.vue?vue&type=script&lang=ts&"
export * from "./Contacts.vue?vue&type=script&lang=ts&"
import style0 from "./Contacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports